<script setup lang="ts">
import type { ImgHTMLAttributes } from "vue"

type Props = {
	placeholder?: boolean | number | string
	placeholderClass?: string
	src: string
	format?: string
	quality?: number | string
	background?: string
	fit?: string
	modifiers?: Record<string, any>
	preset?: string
	provider?: string
	sizes?: string | Record<string, any>
	densities?: string
	preload?: boolean | {
		fetchPriority: "auto" | "high" | "low"
	}
	width?: string | number
	height?: string | number
	alt?: string
	referrerpolicy?: ImgHTMLAttributes["referrerpolicy"]
	usemap?: string
	longdesc?: string
	ismap?: boolean
	loading?: "lazy" | "eager"
	crossorigin?: "anonymous" | "use-credentials" | boolean
	decoding?: "async" | "auto" | "sync"
	nonce?: string
}

const props = defineProps<Props>()
</script>

<template>
	<NuxtImg
		v-bind="props"
		class="size-full object-cover" />
</template>
